import React, { useState, useEffect } from 'react';
import { apiClient } from '../api/client';

function TasksList({ classId }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!classId) return;

    const loadTasks = async () => {
      setLoading(true);
      try {
        const data = await apiClient.get(`/classes/${classId}/tasks`);
        setTasks(data.tasks || []);
      } catch (err) {
        console.error('Failed to load tasks:', err);
      } finally {
        setLoading(false);
      }
    };

    loadTasks();
  }, [classId]);

  const formatTime = (isoString) => {
    if (!isoString) return '-';
    const date = new Date(isoString);
    return date.toLocaleString('et-EE', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '48px', color: '#6b7280' }}>
        Laadin ülesandeid...
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '48px',
        background: '#f9fafb',
        borderRadius: '12px',
        color: '#6b7280'
      }}>
        Pole veel ühtegi ülesannet
      </div>
    );
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '16px'
    }}>
      {tasks.map((task) => (
        <div
          key={task.taskId}
          style={{
            background: 'white',
            borderRadius: '12px',
            padding: '16px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
          }}
        >
          {/* Thumbnail */}
          <div style={{
            width: '100%',
            aspectRatio: '4/3',
            borderRadius: '8px',
            overflow: 'hidden',
            background: '#f3f4f6',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {task.thumbnail ? (
              <img
                src={`data:image/jpeg;base64,${task.thumbnail}`}
                alt="Task thumbnail"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            ) : (
              <span style={{ fontSize: '32px', color: '#d1d5db' }}>📄</span>
            )}
          </div>

          {/* Stats */}
          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontSize: '11px', color: '#9ca3af', marginBottom: '2px' }}>
              Lisatud: {formatTime(task.createdAt)}
            </div>
          </div>

          {/* Metrics */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '8px',
            textAlign: 'center'
          }}>
            <div>
              <div style={{ fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                {task.attemptCount}
              </div>
              <div style={{ fontSize: '10px', color: '#9ca3af' }}>Katseid</div>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: '700', color: '#22c55e' }}>
                {task.correctCount}
              </div>
              <div style={{ fontSize: '10px', color: '#9ca3af' }}>Õigeid</div>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: '700', color: '#ef4444' }}>
                {task.incorrectCount}
              </div>
              <div style={{ fontSize: '10px', color: '#9ca3af' }}>Valesid</div>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: '700', color: '#f59e0b' }}>
                {task.needsReviewCount}
              </div>
              <div style={{ fontSize: '10px', color: '#9ca3af' }}>Ootel</div>
            </div>
          </div>

          {/* Pass rate bar */}
          <div style={{ marginTop: '12px' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '11px',
              marginBottom: '4px'
            }}>
              <span style={{ color: '#6b7280' }}>Õnnestumise %</span>
              <span style={{
                fontWeight: '600',
                color: task.passRate >= 70 ? '#22c55e' :
                       task.passRate >= 40 ? '#f59e0b' : '#ef4444'
              }}>
                {task.passRate}%
              </span>
            </div>
            <div style={{
              height: '6px',
              borderRadius: '3px',
              background: '#e5e7eb',
              overflow: 'hidden'
            }}>
              <div style={{
                height: '100%',
                width: `${task.passRate}%`,
                borderRadius: '3px',
                background: task.passRate >= 70 ? '#22c55e' :
                           task.passRate >= 40 ? '#f59e0b' : '#ef4444',
                transition: 'width 0.3s ease'
              }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TasksList;
